import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import Card from '../Card/Card.js';

const RadioButton = (_param)=> {
    var { name , variant ='outline' , children , className , disabled =false , isChecked , onChange , position ='left' , value , id , 'data-t': dataT  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "variant",
        "children",
        "className",
        "disabled",
        "isChecked",
        "onChange",
        "position",
        "value",
        "id",
        'data-t'
    ]);
    return React.createElement("label", swcHelpers.extends({
        htmlFor: id || value,
        className: classnames('radio-button', `radio-button--${variant}`, `radio-button--${position}`, className),
        "data-t": dataT
    }, rest), /*#__PURE__*/ React.createElement("input", {
        type: "radio",
        name: name || 'radio-button',
        id: id || value,
        "aria-checked": isChecked,
        checked: isChecked,
        disabled: disabled,
        onChange: onChange,
        value: value,
        className: "radio-button__input"
    }), variant === 'outline' ? /*#__PURE__*/ React.createElement(Card.OldCard, {
        className: "radio-button__label"
    }, children) : /*#__PURE__*/ React.createElement("div", {
        className: "radio-button__label"
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: "radio-button__radio-indicator"
    }));
};
var RadioButton$1 = RadioButton;

export { RadioButton$1 as default };
//# sourceMappingURL=RadioButton.js.map
